
import { Options, Vue } from "vue-class-component";
import {PcMain,SystemHeader,SystemMenu,PcTabsBar,Breadcrumb} from './components';
import {computerPageList} from '@/constant/whitelist'
import { useStore } from "@/store";

@Options({
  components: {
    PcMain,
    SystemHeader,
    SystemMenu,
    PcTabsBar,
    Breadcrumb
  },
})
export default class SystemHome extends Vue {
  get show(){
    return computerPageList.indexOf(this.$route.path) > -1
  }
  get inScreenfull() { //全屏预览
    return useStore().state.dataAnalysis.screenfull;
  }
  created(): void {
  }
}
